import { Icon } from '../../../icons';
import styles from './loader.module.css';

const Loader = () => (
  <div className={styles['loading-overlay']}>
    <Icon color="primary" icon="loading-line" size="large" spin />
  </div>
);

export default Loader;
